// Libraries
import React, { LegacyRef, useRef } from "react";
import { EditableInput, observable, useObserver, useContext, useEffect, useState } from "@shoothill/core";
import * as Mui from "@material-ui/core";

// Custom

// Components
import { StoresContext, Stores } from "Globals/Stores";
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";

// Styling & images
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { Box, Button, Modal } from "@material-ui/core";
import styled from "styled-components";
import { CrossSVG } from "Globals/Views/IconSVGs/CrossSVG";
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
// TODO Move styles to separate file
// TODO implement theme colors instead of hardcoded hex values
export const ModalBase: any = styled(Modal)`
    padding: 0px;
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    max-width: 400px;

    .modalhead,
    .modalbody {
        padding: 10px 15px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }

    .modalhead {
        border-radius: 5px 5px 0px 0px;
        background-color: #84bb25;
        color: white;

        h2 {
            margin: 0 auto;
            font-size: 1.8em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }
    .modalbody {
        border-radius: 0px 0px 5px 5px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        padding-left: 1em;
        text-indent: -0.7em;
        font-size: 12px;
    }

    li::before {
        content: "•";
        padding-right: 7px;
        color: #19bb00;
    }
`;
export const ModelButtonsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    button {
        border-radius: 0px;
        display: flex;
        flex: 1 50%;
        color: white;
        font-size: 12px;
        background-color: #3c3c3b;
    }
    button:first-child {
        background-color: #19bb00;
    }
`;

interface IProps {
    isActive: boolean;
    paymentViewModel: PaymentViewModel;
    adminApplicantViewModel: AdminApplicantViewModel;
    confirmClose(confirm: boolean): void;
    onCancel(): void;
}

export const PaymentModal: React.FC<IProps> = (props) => {
    const domain = useContext<Stores>(StoresContext).Domain;
    let gateway: any;
    const ref: LegacyRef<HTMLFormElement> = useRef(null);

    // useEffect(() => {
    //     console.log(`adding listener`);
    //     gateway = new AllpayGateway("https://gateway.trn.allpay.net", "PaymentIFrame", onCompleteEvent);
    //     window.addEventListener("click", listener);

    //     return () => {
    //         console.log(`removing listener`);
    //         window.removeEventListener("click", listener);
    //     };
    // }, []);

    useEffect(() => {
        ref.current?.submit();
    }, [props.paymentViewModel.allPayToken]);

    return useObserver(() => (
        <>
            <ModalBase open={props.isActive} onClose={() => props.onCancel()}>
                <div>
                    {/* <Box className="modalhead" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "800px" }}>
                        <Mui.Typography variant="h6">Pay registration fee</Mui.Typography>
                        <div style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => props.onCancel()}>
                            <CrossSVG />
                        </div>
                    </Box> */}
                    <div className="modalbody">
                        {props.paymentViewModel.allPayToken && (
                            <iframe name="PaymentIFrame" id="PaymentIFrame" style={{ height: "66vh", width: "100%", maxWidth: "90vw", paddingTop: "20px" }} title="Payment IFrame">
                                <form id="IFrameForm" method="post" target="PaymentIFrame" action={props.paymentViewModel.allPayBaseUrl} ref={ref}>
                                    <input type="hidden" id="FormCustomerReferenceInput" name="CustomerReference" value={props.adminApplicantViewModel.model.surname} />
                                    <input type="hidden" id="FormAmountInput" name="Amount" value="500.00" />
                                    <input type="hidden" id="FormPaymentReasonInput" name="PaymentReason" value="SO Reservation Fee" />
                                    <input type="hidden" id="FormClientCodeInput" name="ClientCode" value="HTOT" />
                                    <input type="hidden" id="FormTokenInput" name="Token" value={props.paymentViewModel.allPayToken} />
                                </form>
                            </iframe>
                        )}
                    </div>
                </div>
            </ModalBase>
        </>
    ));
};
